import React, { FC } from "react";
import styles from "./About.module.scss";
import atendimentoCasa from "./../../../../Static/Images/Icones/Atendimento-domicílio.png";
import PraticidadeNaSolicitação from "./../../../../Static/Images/Icones/Praticidade-na-solicitação.png";
import Comodidade from "./../../../../Static/Images/Icones/Comodidade.png";
import planoPrevencao from "./../../../../Static/Images/Icones/Plano-de-prevenção.png";
import { isIOS, isMacOs, isMobile } from "react-device-detect";
import PhoneImg from "./../../../../Static/Images/About/Phone.png";
import AtendimentoImg from "./../../../../Static/Images/About/Atendimento.png";
import VetSaudeIconImg from "./../../../../Static/Images/About/VetSaude.png";
import QualidadeImg from "./../../../../Static/Images/About/Qualidade.png";
import PraticidadeImg from "./../../../../Static/Images/About/Praticidade.png";
import { SiteButton } from "../../../../Components/UI/Button/Button.style";

export const About: FC = () => {
  return (
    <div className={`${styles["About"]} ${isMobile ? styles["mobile"] : ""}`}>
      <div className={styles["Content"]}>
        <div className={styles["left"]}>
          <p>
            Manter a saúde <br />
            do seu pet em dia <br />
            nunca foi tão fácil.
          </p>
          <p></p>
        </div>
        <div className={styles["phone"]}>
          <img src={PhoneImg} />
          {isMobile && (
            <div className={styles["right"]}>
              <p>
                Vacinas <b>importadas</b>, consultas,
                <br /> atendimento emergencial com profissionais <br />
                credenciados e altamente capacitados. <br /> Com o aplicativo
                QueroVet você tem
                <br /> todos esses benefícios sempre na sua
                <br /> mão.
              </p>
            </div>
          )}
        </div>
        {!isMobile && (
          <div className={styles["right"]}>
            <p>
              Vacinas <b>importadas</b>, consultas, atendimento emergencial com
              profissionais credenciados e altamente capacitados. Com o
              aplicativo QueroVet você tem todos esses benefícios sempre na sua
              mão.
            </p>
          </div>
        )}
      </div>
      <div className={styles["Items"]}>
        <img src={AtendimentoImg} />
        <img src={PraticidadeImg} />
        {!isMobile && <div />}
        <img src={QualidadeImg} />
        <img src={VetSaudeIconImg} />
      </div>
      <div className={styles["app"]}>
        <SiteButton
          className={styles["baixarapp"]}
          onClick={() => {
            if (isMacOs) {
              window.open(process.env.REACT_APP_IOS_URL);
            } else if (isIOS) {
              window.open(process.env.REACT_APP_IOS_URL);
            } else {
              window.open(process.env.REACT_APP_ANDROID_URL);
            }
          }}
          color="--bg-white"
        >
          BAIXE AGORA O APLICATIVO
        </SiteButton>
      </div>
    </div>
  );
};
